import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ZoomInIcon } from 'lucide-react';
interface GallerySectionProps {
  onNavigate: (page: string) => void;
}
const PREVIEW_IMAGES = [{
  url: 'https://cdn.magicpatterns.com/uploads/kz8rhY5ZFL3afPmoLdfTj6/IMG-20250203-WA0002.jpg',
  caption: 'Letecký pohled na areál'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/g9Js7824QWNHMaLnV96npj/20260110_135324.jpg',
  caption: 'Interiér výrobní haly'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/rQNTQgt7KREVKpGzy1XWyB/20260110_135334.jpg',
  caption: 'Výrobní prostory s regály'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/wgSDBnrqaxxzF2WNihwwiv/20260102_192350.jpg',
  caption: 'Noční pohled na areál'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3VToVwxypuTMGqY5qyipri/20251217_113431.jpg',
  caption: 'Areál v denním světle'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/cutUXFvXwjrjTeD1C75Zzd/20251217_111204.jpg',
  caption: 'Dvůr areálu s nákladní technikou'
}];
export function GallerySection({
  onNavigate
}: GallerySectionProps) {
  const openGalleryAtIndex = (index: number) => {
    onNavigate(`gallery:${index}`);
  };
  return <>
      <section id="galerie" className="py-24 bg-neutral-950" data-id="element-106">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
          <div className="mb-12 flex flex-col sm:flex-row justify-between items-end gap-4" data-id="element-108">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold text-white" data-id="element-109">
              Galerie
            </motion.h2>
            <motion.button initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} onClick={() => onNavigate('gallery')} className="hidden sm:inline-flex items-center text-[#e0a812] hover:text-[#c4920f] font-medium transition-colors" data-id="element-110">
              Zobrazit celou galerii <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-111" />
            </motion.button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-112">
            {PREVIEW_IMAGES.map((img, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`relative group overflow-hidden rounded-sm bg-neutral-800 cursor-pointer ${index === 0 ? 'sm:col-span-2 lg:col-span-1' : ''}`} onClick={() => openGalleryAtIndex(index)} data-id="element-113">
                <div className="aspect-w-16 aspect-h-10 w-full h-full min-h-[250px]" data-id="element-114">
                  <img src={img.url} alt={img.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 opacity-90 group-hover:opacity-100" data-id="element-115" />
                </div>
                <div className="absolute inset-0 bg-neutral-950/0 group-hover:bg-neutral-950/40 transition-colors duration-300 flex items-center justify-center" data-id="element-116">
                  <ZoomInIcon className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-10 h-10" data-id="element-117" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 px-4 pb-5 pt-10 bg-gradient-to-t from-neutral-950/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-118">
                  <p className="text-neutral-300 text-xs font-medium" data-id="element-119">
                    {img.caption}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center sm:hidden" data-id="element-120">
            <button onClick={() => onNavigate('gallery')} className="inline-flex items-center justify-center px-6 py-3 border border-[#e0a812] text-[#e0a812] hover:bg-[#e0a812] hover:text-white font-medium rounded-sm transition-colors w-full" data-id="element-121">
              Zobrazit celou galerii <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-122" />
            </button>
          </div>
        </div>
      </section>
    </>;
}